import { HttpClient, HttpResponse } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

const API_URL = environment.apiURL
const PYANALITICS_URL = environment.pyAnaliticsURL
const BOREAL_URL = environment.borealURL

@Injectable({ providedIn: 'root' })
export class FileRepositoryService {
  private httpClient: HttpClient = inject(HttpClient)

  public uploadFile(formData: FormData): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${API_URL}/centralweb/custom/upload`, formData, { observe: 'response' })
  }

  public uploadFileS3Boreal(formData: FormData): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${BOREAL_URL}/upload/s3`, formData, { observe: 'response' })
  }

  public downloadAttachmentWorkflow(attachmentId: number): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${PYANALITICS_URL}/workflow/download-anexo?anexoId=${attachmentId}`, { observe: 'response', responseType: 'blob' })
  }

  public downloadBatchAttachmentWorkflow(payload: Object): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${PYANALITICS_URL}/workflow/download-todos-anexos-zip`, payload, { observe: 'response', responseType: 'blob' })
  }

  public deleteAttachmentWorkflow(payload: Object): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${PYANALITICS_URL}/workflow/excluir-anexo`, payload, { observe: 'response' })
  }

  public downloadS3File(payload: Object): Observable<HttpResponse<Blob>> {
    return this.httpClient.post(`${PYANALITICS_URL}/s3/baixar-arquivo`, payload, { observe: 'response', responseType: 'blob' })
  }
}
